import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../client';
export function fetchClientInfo() {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_CLIENT_INFO
            },
            _a[CALL_API] = {
                endpoint: "/get-ip",
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_FETCH_CLIENT_INFO,
                    ActionTypes.FAILURE_FETCH_CLIENT_INFO
                ]
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/client.js